const subcat = {
  categories: document.querySelectorAll(
    '.jsSubCats',
  ) as NodeListOf<HTMLElement>,

  init() {
    this.setAltImages();
  },

  setAltImages() {
    this.categories.forEach((item) => {
      const altSrc = item.dataset.alt;
      const img = item.querySelector('img') as HTMLImageElement | null;

      if (!img || !altSrc) return;

      const originalSrc = img.currentSrc || img.src;
      let altImageLoaded = false;

      const preloadAltImage = () => {
        if (altImageLoaded) return;

        const preloadImage = new Image();

        preloadImage.onload = () => {
          altImageLoaded = true;
        };

        preloadImage.src = altSrc;
      };

      if (document.readyState === 'complete') {
        preloadAltImage();
      } else {
        window.addEventListener('load', preloadAltImage, { once: true });
      }

      item.addEventListener('mouseenter', () => {
        img.src = altSrc;
      });

      item.addEventListener('mouseleave', () => {
        img.src = originalSrc;
      });
    });
  },
};

export default subcat;
